import { useState, useEffect, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface I18nProviderProps {
  children: ReactNode;
}

// I18nProvider to ensure translations are loaded before rendering
const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const { ready } = useTranslation();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (ready) {
      setIsInitialized(true);
    }
  }, [ready]);

  if (!isInitialized) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return <>{children}</>;
};

export default I18nProvider;